import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { AllPersonnelContext } from "repository/stores/dashboard/personnel/personnel-all-provider";
import styles from "./dialogues-edit-experience-styles";
import {
  Grid,
  Button,
  TextField,
  FormControl,
  Paper,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  IconButton,
} from "@material-ui/core";
import SubjectIcon from "@material-ui/icons/Subject";
import DeleteIcon from "@material-ui/icons/Delete";
import { withSnackbar } from "notistack";
import { toast } from "react-toastify";
import Popup from "components/popup";

//Actions
import { updateNewPersonnel } from "repository/actions/data/dashboard/personnel";
const useStyles = makeStyles(styles);

function EditExperienceDialogue(props) {
  const classes = useStyles();

  const { setClose, isOpen, personId, person, setExperience, user } = props;
  const {personnel, setPersonnel} = React.useContext(AllPersonnelContext);

  const [experienceEntries, setExperienceEntries] = React.useState([]);
  const [saveLoading, setSaveLoading] = React.useState(false);
  const [newExperienceEntry, setNewExperienceEntry] = React.useState(null);
  const [newExperienceEntryError, setNewExperienceEntryError] =
    React.useState(null);

  useEffect(() => {
    if (person && person != null) {
      if (person.experience) {
        setExperienceEntries(person.experience);
      }
    }
  }, [person]);

  const handleAddNewExperienceEntry = () => {
    if (newExperienceEntry == null) {
      setNewExperienceEntryError("Cannot have an empty experience");
    } else {
      let newExperienceEntries = [newExperienceEntry].concat(experienceEntries);
      setExperienceEntries(newExperienceEntries);
      setNewExperienceEntryError(null);
    }
  };

  const handleSaveExperienceEntries = () => {
    if (user && user != null) {
      let patchData = { ...person, experience: experienceEntries };
      updateNewPersonnel(personId, patchData, user.idToken)
        .then((result) => {
          toast.success(
            `Highest qualifications for ${person.firstName} ${person.lastName} updated`
          );
          setExperience(experienceEntries);
          handleClose();
          setSaveLoading(false);
        })
        .catch((error) => {
          toast.error(
            "Oops! Something went wrong. Check that you have the correct information."
          );
          toast.dark(error.message);
          setSaveLoading(false);
        });
    }
  };

  const onPressedDeleteExperienceEntry = (index) => {
    if (experienceEntries.length > index) {
      let newExperienceEntries = [];

      for (let [i, e] of experienceEntries.entries()) {
        if (i != index) {
          newExperienceEntries.push(e);
        }
      }
      setExperienceEntries(newExperienceEntries);
    }
  };

  const handleClose = () => {
    setClose();
  };

  return (
    <Popup
      title="Experience"
      subtitle="Edit this person's experience"
      isOpen={isOpen}
      handleCancel={() => handleClose()}
      handleAction={() => handleSaveExperienceEntries()}
      actionButtonTitle="Save"
      disabled={saveLoading}
      content={
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Paper className={classes.fullColumn}>
                <FormControl className={classes.formControl}>
                  <TextField
                    placeholder={"Ex: Experience in Pharmaceuticals"}
                    disabled={saveLoading}
                    required
                    helperText={newExperienceEntryError}
                    error={newExperienceEntryError != null}
                    label="New Experience"
                    value={newExperienceEntry}
                    onChange={(event) =>
                      setNewExperienceEntry(event.target.value)
                    }
                    margin="normal"
                  />
                </FormControl>
                <FormControl className={classes.formControl}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.submitButton}
                    onClick={() => handleAddNewExperienceEntry()}
                  >
                    Add Qualification
                  </Button>
                </FormControl>
              </Paper>
            </Grid>
            <Grid item xs={6}>
              <Paper className={classes.fullColumn}>
                <List className={classes.root}>
                  {experienceEntries.map((entry, index) => {
                    return (
                      <ListItem key={index}>
                        <ListItemAvatar>
                          <Avatar>
                            <SubjectIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Grid container spacing={3}>
                              <Grid item xs={9}>
                                {entry}
                              </Grid>
                              <Grid item xs={3}>
                                <IconButton
                                  aria-label="delete"
                                  color="primary"
                                  onClick={(event) => {
                                    onPressedDeleteExperienceEntry(index);
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </Grid>
                            </Grid>
                          }
                        />
                      </ListItem>
                    );
                  })}
                </List>
              </Paper>
            </Grid>
          </Grid>
        </div>
      }
    />
  );
}

export default withSnackbar(EditExperienceDialogue);
